module.exports = __webpack_public_path__ + "static/fonts/iconfont.f5b3232.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.eot?t=1555750596622
// module id = Ui4e
// module chunks = 38